import { useEffect } from "react";
import Lenis from "lenis";
import { scrollStore, stageFromProgress } from "@/lib/scrollStore";
import { STAGES } from "@/content";

// Initializes Lenis smooth scroll and keeps scrollStore in sync.
// Returns nothing — mount once at the top of the tree.
export function useLenis() {
  useEffect(() => {
    // Skip on touch devices where momentum-scroll feels worse than native.
    const coarse =
      typeof window !== "undefined" &&
      window.matchMedia("(pointer: coarse)").matches;

    const lenis = new Lenis({
      lerp: coarse ? 0.12 : 0.085,
      wheelMultiplier: 1,
      smoothWheel: true,
      smoothTouch: false,
      autoRaf: true,
    });
    if (typeof window !== "undefined") window.__lenis = lenis;

    const onScroll = ({ scroll, limit }) => {
      const p = limit > 0 ? scroll / limit : 0;
      const s = stageFromProgress(p, STAGES);
      scrollStore.set(p, s);
    };
    lenis.on("scroll", onScroll);

    // initial sync
    onScroll({ scroll: window.scrollY || 0, limit: (document.documentElement.scrollHeight - window.innerHeight) || 1 });

    return () => {
      lenis.destroy();
    };
  }, []);
}
